import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { styled, Box } from '@mui/material';
import { forwardRef } from 'react';
import { CLASSES as CLASSES$1 } from '../Button/classes.js';
import { CLASSES } from '../ButtonDeprecated/Button.js';

/**
 * @deprecated Use `Toast` instead and benefit from  brand-new composition API.
 * This component is scheduled for removal around 21.10.2024.
 * To let us know about blockers you can link [FBI-316](https://supercharged.atlassian.net/browse/FBI-316) in your tasks.
 */
const ToastDeprecated = forwardRef(function Toast(_a, ref) {
    var { children, variant } = _a, props = __rest(_a, ["children", "variant"]);
    return (jsx(ToastWrapper, Object.assign({ "$variant": variant, ref: ref }, props, { children: children })));
});
const ToastWrapper = styled(Box, {
    name: "VoltToast",
    slot: "Root",
})(({ theme, $variant }) => (Object.assign({ display: "flex", borderRadius: 8, color: theme.palette.text.white }, generateToastVariant($variant, theme))));
const ContentFooter = styled(Box)(({ theme }) => ({
    display: "flex",
    marginTop: theme.spacing(2),
    [`.${CLASSES.button}:only-child, .${CLASSES$1.wrapper}:only-child`]: {
        width: "100%",
    },
    [`.${CLASSES.button}:first-child:nth-last-child(2), .${CLASSES$1.wrapper}:first-child:nth-last-child(2)`]: {
        width: "50%",
        marginRight: theme.spacing(1),
    },
    [`.${CLASSES.button}:first-child:nth-last-child(2) ~ .${CLASSES.button}, .${CLASSES$1.wrapper}:first-child:nth-last-child(2) ~ .${CLASSES$1.wrapper}`]: {
        width: "50%",
    },
}));
const ContentWrapper = styled(Box)(({ theme }) => (Object.assign({ display: "flex", flexDirection: "column", padding: theme.spacing(2.5, 2.5, 2.5, 0), minWidth: 240, overflowWrap: "break-word" }, theme.typography.h6)));
const IconWrapper = styled(Box)(({ theme }) => (Object.assign({ display: "flex", justifyContent: "center", minWidth: 60, padding: theme.spacing(2.5, 2, 0, 2.5) }, theme.typography.h6)));
const RootWrapper = styled(Box)({
    width: 300,
    display: "flex",
});
function generateToastVariant(variant, theme) {
    switch (variant) {
        case "info":
            return {
                backgroundColor: theme.palette.primary[800],
                boxShadow: `0px 2px 2px rgba(26, 99, 171, 0.2),
                0px 4px 8px rgba(32, 37, 43, 0.2)`,
            };
        case "failure":
            return {
                backgroundColor: theme.palette.failure[700],
                boxShadow: `0px 2px 2px rgba(219, 28, 28, 0.2),
                0px 4px 8px rgba(32, 37, 43, 0.2)`,
            };
        case "success":
            return {
                backgroundColor: theme.palette.success[500],
                boxShadow: `0px 2px 2px rgba(30, 168, 163, 0.2),
                0px 4px 8px rgba(32, 37, 43, 0.2)`,
            };
        default:
            return {
                border: `1px solid ${theme.palette.ui50}`,
                color: theme.palette.text.highlight,
                backgroundColor: theme.palette.ui30,
                boxShadow: `0px 2px 2px rgba(26, 99, 171, 0.15),
                0px 4px 8px rgba(32, 37, 43, 0.15)`,
            };
    }
}
ToastDeprecated.ContentFooter = ContentFooter;
ToastDeprecated.ContentWrapper = ContentWrapper;
ToastDeprecated.IconWrapper = IconWrapper;
ToastDeprecated.RootWrapper = RootWrapper;

export { ToastDeprecated };
//# sourceMappingURL=ToastDeprecated.js.map
